module.exports = __webpack_public_path__ + "static/media/GLOWMATH.3df4bc93.png";